import React, { useMemo } from "react";
import { Source, Layer } from "react-map-gl/mapbox";
import {
  buildAllowedMunicipalitiesFilter,
  buildOutsideAllowedMunicipalitiesFilter,
} from "./mapInitialView";

const MUNICIPALITIES_SOURCE_URL = "mapbox://georgemouts.55l8r190";
const MUNICIPALITIES_SOURCE_LAYER = "municipalities";

export const MUNICIPALITY_SCOPE_LAYER_IDS = {
  portfolio: {
    boundarySourceId: "municipalities-source",
    boundaryFillLayerId: "municipalities-layer-fill",
    boundaryLineLayerId: "municipalities-layer-line",
    maskSourceId: "municipalities-outside-mask-source",
    maskLayerId: "municipalities-outside-mask-layer",
  },
  risks: {
    boundarySourceId: "municipalities-source-risks",
    boundaryFillLayerId: "municipalities-layer-fill-risks",
    boundaryLineLayerId: "municipalities-layer-line-risks",
    maskSourceId: "municipalities-outside-mask-source-risks",
    maskLayerId: "municipalities-outside-mask-layer-risks",
  },
};

export default function MunicipalityScopeLayers({
  allowedMunicipalityIds,
  boundarySourceId,
  boundaryFillLayerId,
  boundaryLineLayerId,
  maskSourceId,
  maskLayerId,
  boundaryLineWidth = 1,
  maskFillOpacity = 0.78,
}) {
  const allowedMunicipalitiesFilter = useMemo(
    () => buildAllowedMunicipalitiesFilter(allowedMunicipalityIds),
    [allowedMunicipalityIds],
  );
  const outsideAllowedMunicipalitiesFilter = useMemo(
    () => buildOutsideAllowedMunicipalitiesFilter(allowedMunicipalityIds),
    [allowedMunicipalityIds],
  );

  return (
    <>
      <Source
        id={boundarySourceId}
        url={MUNICIPALITIES_SOURCE_URL}
        type="vector"
        promoteId={{ municipalities: "id" }}
      >
        <Layer
          id={boundaryFillLayerId}
          type="fill"
          source-layer={MUNICIPALITIES_SOURCE_LAYER}
          filter={allowedMunicipalitiesFilter}
          paint={{
            "fill-color": "rgba(0, 0, 0, 0)",
            "fill-opacity": 0.01,
          }}
        />
        <Layer
          id={boundaryLineLayerId}
          type="line"
          source-layer={MUNICIPALITIES_SOURCE_LAYER}
          filter={allowedMunicipalitiesFilter}
          paint={{ "line-color": "black", "line-width": boundaryLineWidth }}
        />
      </Source>

      <Source
        id={maskSourceId}
        url={MUNICIPALITIES_SOURCE_URL}
        type="vector"
      >
        <Layer
          id={maskLayerId}
          type="fill"
          source-layer={MUNICIPALITIES_SOURCE_LAYER}
          filter={outsideAllowedMunicipalitiesFilter}
          paint={{
            "fill-color": "#ffffff",
            "fill-opacity": maskFillOpacity,
          }}
        />
      </Source>
    </>
  );
}
